export { default } from './top-comment-icon-link';
